@if (filtersForm() && controlName()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <div
    class="last-x-records-filter filter-body"
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
  >
    <form [formGroup]="filtersForm()" class="last-x-records-filter__form">
      <mat-form-field class="last-x-records-filter__form-field" appearance="outline">
        <span matTextPrefix>Last&nbsp;</span>
        <input
          min="1"
          max="{{ maxValue }}"
          matInput
          type="number"
          #input
          maxlength="6"
          [formControlName]="controlName()"
          (input)="getValueFromLastXInput(input)"
        />
        <span matTextSuffix>records&nbsp;</span>
      </mat-form-field>
    </form>
  </div>
}
